import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { PauseCircle, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaDemandaInterrompida = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes('demanda interrompida') || 
           acaoLower.includes('interrompeu demanda') ||
           acaoLower.includes('interromper demanda');
};

const getIconDemandaInterrompida = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: PauseCircle, color: 'var(--cf59e0b)' };
};

export default function CardDemandaInterrompida({ 
    item, 
    onNavigateToFile, 
    isExpanded, 
    onToggleExpand 
}: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconDemandaInterrompida(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={
                <ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />
            }
        />
    );
}

export const demandaInterrompidaConfig = {
    tipo: 'demanda_interrompida',
    detectaTipo: detectaDemandaInterrompida,
    getIcon: getIconDemandaInterrompida,
    temExpansao: () => true,
    Component: CardDemandaInterrompida
};

